export default __webpack_public_path__ + "static/media/O-112.429dc623.png";